<template>
  <div>
    <p>
      The points of the mesh are distributed according to the mesh element
      definition. The longitudes of the point
      have always a constant step, and the latitudes can be distributed
      according to the following definitions:
    </p>
    <ul>
      <li><b>Constant step</b></li>
      <li><b>Constant area</b></li>
    </ul>
    <br />

    <p>
      For a <b>constant step</b>, the latitudes are evenly spaced, with a
      constant latitude step, resulting in a uniform distribution along the
      chosen latitude range.
    </p>
    <p>
      For a <b>constant area</b>, the latitudes are chosen so that the areas of
      each element is always constant. This is obtained by increasing the
      latitude step closer to the poles, resulting in more elongated elements.
      Mathematically, the constant element area is achieved via a constant step
      of the sinus of the latitude, <i>i.e</i>:
    </p>

    <katex-element
      expression="\sin(\phi_k) - \sin(\phi_{k-1}) = \sin(\phi_{k+1}) - \sin(\phi_{k})"
    />

    <br />
    <br />

    <p>
      where <katex-element expression="\phi_k" /> is the latitude of the
      <katex-element expression="k" />-th point along a meridian.
    </p>

    <p>
      For analysing statistics on the spatial distribution of metrics, for
      example in the 'Statistics Histogram' on the performance analysis mission
      dashboard, it is recommended to use <b>constant area</b>. If a
      <b>constant step</b> is used instead, there will be a higher concentration
      of points closer to the poles, thus giving more importance to the results
      on those regions.
    </p>

    <i>Nota Bene: </i> if <b>constant area</b> is selected and the
    <b>mesh definition type</b> is set to <i>'Step'</i>, the field
    <i>'Latitude step'</i> will correspond to the maximum latitude step of the
    mesh (found around the closest points to the poles).
  </div>
</template>

<script>
export default {
  name: 'tooltipEarthMeshElementDefinition'
}
</script>
